import { useEffect, useState } from "react";

// setTimeout fires at once for a delay past its 32-bit limit (~24.8 days).
const MAX_TIMER_MS = 2 ** 31 - 1;

/**
 * The current time (ms), refreshed once `deadlineMs` passes, so a control greyed until then is
 * released on time even when nothing else re-renders. Null `deadlineMs`, or one the returned
 * time is already past, sets no timer.
 *
 * @param {number|null} deadlineMs
 * @returns {number}
 */
export function useDeadlineClock(deadlineMs) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (deadlineMs == null || !Number.isFinite(deadlineMs) || deadlineMs <= now) return undefined;
    // A far deadline is waited for in steps: each step's new time schedules the next.
    const wait = Math.min(MAX_TIMER_MS, Math.max(0, deadlineMs - Date.now()) + 50);
    const t = setTimeout(() => setNow(Date.now()), wait);
    return () => clearTimeout(t);
  }, [deadlineMs, now]);
  return now;
}
